import React, { useEffect, useState, memo } from "react";
import {
  Typography,
  Input,
  Select,
  Row,
  Col,
  Divider,
  Switch,
  Space,
} from "antd";
import Sider from "antd/es/layout/Sider";
import "./SiderComponent.css";

const { Title, Text } = Typography;
const { TextArea } = Input;

interface LeftSiderComponentProps {
  prompt: string;
  setPrompt: (prompt: string) => void;
  model: string;
  setModel: (model: string) => void;
  compareMode?: boolean;
  setCompareMode?: (enabled: boolean) => void;
  modelA?: string;
  setModelA?: (model: string) => void;
  modelB?: string;
  setModelB?: (model: string) => void;
}

const LeftSiderComponent: React.FC<LeftSiderComponentProps> = ({
  prompt,
  setPrompt,
  model,
  setModel,
  compareMode = false,
  setCompareMode,
  modelA = "breeze",
  setModelA,
  modelB = "breeze",
  setModelB,
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Sider
      width={400}
      className="LeftSider"
      style={{
        background: "#fff",
        borderRight: "1px solid rgba(0,0,0,0.1)",
      }}>
      <div className={`left-sider-content ${isMobile ? "mobile" : ""}`}>
        {!isMobile && (
          <Typography
            style={{
              fontSize: "20px",
              fontWeight: "700",
              color: "rgba(0,0,0,0.2)",
              textAlign: "center",
              marginBottom: "20px",
            }}>
            Configuration
          </Typography>
        )}

        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            background: "rgba(0,0,0,0.02)",
            borderRadius: "10px",
            padding: isMobile ? "10px 8px" : "20px 20px",
            gap: isMobile ? "10px" : "20px",
            boxSizing: "border-box",
            maxWidth: "100%",
          }}>
          <Row style={{ width: "100%" }}>
            <Col span={24}>
              <Space style={{ width: "100%", justifyContent: "space-between" }}>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "rgba(0,0,0,0.8)",
                    textAlign: "start",
                  }}>
                  Compare Mode
                </Typography>
                <Switch
                  checked={compareMode}
                  onChange={(checked) =>
                    setCompareMode && setCompareMode(checked)
                  }
                />
              </Space>
            </Col>
          </Row>

          <Divider style={{ margin: isMobile ? "8px 0" : "12px 0" }} />

          {!compareMode && (
            <>
              <Row style={{ width: "100%" }}>
                <Col
                  span={isMobile ? 24 : 10}
                  style={{ marginBottom: isMobile ? "5px" : "0" }}>
                  <Typography
                    style={{
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "rgba(0,0,0,0.8)",
                      textAlign: "start",
                    }}>
                    Model
                  </Typography>
                </Col>
                <Col span={isMobile ? 24 : 14}>
                  <Select
                    value={model}
                    onChange={setModel}
                    style={{ width: "100%" }}
                    placeholder="Select a model">
                    <Select.Option value="breeze">breeze</Select.Option>
                    <Select.Option value="openai/whisper-v3-large">
                      openai/whisper-v3-large
                    </Select.Option>
                    <Select.Option value="deepgram:nova-3">
                      deepgram/nova-3
                    </Select.Option>
                  </Select>
                </Col>
              </Row>
            </>
          )}

          {compareMode && (
            <>
              <Row style={{ width: "100%" }}>
                <Col
                  span={24}
                  style={{ marginBottom: isMobile ? "4px" : "8px" }}>
                  <Typography
                    style={{
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "rgba(0,0,0,0.8)",
                      textAlign: "start",
                    }}>
                    Model A
                  </Typography>
                </Col>
                <Col span={24}>
                  <Select
                    value={modelA}
                    onChange={(val) => setModelA && setModelA(val)}
                    style={{ width: "100%" }}
                    placeholder="Select Model A">
                    <Select.Option value="breeze">breeze</Select.Option>
                    <Select.Option value="openai/whisper-v3-large">
                      openai/whisper-v3-large
                    </Select.Option>
                    <Select.Option value="deepgram:nova-3">
                      deepgram/nova-3
                    </Select.Option>
                  </Select>
                </Col>
              </Row>
              <Row
                style={{ width: "100%", marginTop: isMobile ? "8px" : "12px" }}>
                <Col
                  span={24}
                  style={{ marginBottom: isMobile ? "4px" : "8px" }}>
                  <Typography
                    style={{
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "rgba(0,0,0,0.8)",
                      textAlign: "start",
                    }}>
                    Model B
                  </Typography>
                </Col>
                <Col span={24}>
                  <Select
                    value={modelB}
                    onChange={(val) => setModelB && setModelB(val)}
                    style={{ width: "100%" }}
                    placeholder="Select Model B">
                    <Select.Option value="breeze">breeze</Select.Option>
                    <Select.Option value="openai/whisper-v3-large">
                      openai/whisper-v3-large
                    </Select.Option>
                    <Select.Option value="deepgram:nova-3">
                      deepgram/nova-3
                    </Select.Option>
                  </Select>
                </Col>
              </Row>
            </>
          )}
          <Row style={{ width: "100%" }}>
            <Col span={24} style={{ marginBottom: "8px" }}>
              <Typography
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "rgba(0,0,0,0.8)",
                  textAlign: "start",
                }}>
                Prompt
              </Typography>
            </Col>
          </Row>
          <Row style={{ width: "100%" }}>
            <Col span={24}>
              <TextArea
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                placeholder="Enter your custom prompt here..."
                rows={3}
                style={{ marginBottom: "12px" }}
              />
            </Col>
          </Row>
        </div>
      </div>
    </Sider>
  );
};

export default memo(LeftSiderComponent);
